
var seguros = {
    autos: "Seguro de Autos",
    autosflotilla: "Seguro de Autos Flotilla",
    vida: 'Seguro de Vida',
    danios: 'Seguro Contra Daños',
    medicosmayores: 'Seguro de Gastos Médicos Mayores',

};

export default {
    seguros
}
